var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartHome = function SvgSmartHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FDEEF2;}\r\n\t.st1{fill:#DB1182;}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,11.5c0-0.1-0.1-0.1-0.1-0.2c-0.4-1.9-1.4-3.5-2.9-4.8c-1.8-1.5-3.9-2.1-6.2-1.9c-0.5,0-0.9,0.4-0.9,0.8 c-0.1,0.6,0.4,1.1,1.1,1.1c2.1-0.2,3.9,0.5,5.4,2c1,1.1,1.6,2.4,1.8,3.8c0.1,0.6,0.5,1,1,0.9c0.5,0,0.8-0.4,0.9-0.8 C32.6,12.1,32.6,11.8,32.5,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.3,8.9c-0.6,0.1-1,0.5-0.9,1c0,0.5,0.5,0.9,1.1,0.9c1.6-0.1,2.8,0.9,3.1,2.5c0,0.2,0.2,0.5,0.4,0.7 c0.3,0.3,0.7,0.3,1,0.1c0.4-0.3,0.5-0.6,0.4-1.1C28.1,10.5,25.7,8.6,23.3,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.9,10.3c-0.5-0.4-1.2-0.4-1.7,0l-7.4,6.3c-0.3,0.3-0.5,0.6-0.5,1v12.1c0,0.7,0.6,1.3,1.3,1.3h14.9 c0.7,0,1.3-0.6,1.3-1.3V17.6c0-0.4-0.2-0.8-0.5-1L19.9,10.3z M26.1,29.3H12.1V17.8l7-6l7.1,6V29.3z"
  }))));
};
export default SvgSmartHome;